export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const CHECK_SUCCESS = "CHECK_SUCCESS";
export const AUTH_CHECK = "AUTH_CHECK";
export const SAVE_USER_LOGIN_DATA = "SAVE_USER_LOGIN_DATA";
